
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'

import UserProfile from '../pages/Dashboard/Pages/UserProfile'
import Permissions from '../pages/Dashboard/Pages/Permissions'
import UserGroupPermissions from '../pages/Dashboard/Pages/UserGroupPermissions'
import EditUserProfile from '../pages/Dashboard/Pages/UserProfileComponents/EditProfile'
import ChangePassword from '../pages/Dashboard/Pages/UserProfileComponents/ChangePassword'

const userPages = {
  path: '/',
  name: 'Users',
  title: 'Usuarios',
  component: DashboardLayout,
  excludedGroups: [ 'Extranet' ],
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/permissions',
      name: 'Permisos de Usuario',
      title: 'Permisos',
      component: Permissions,
      meta: {
        ifUserCan: {
          view: 'Users/modulepermissions'
        }
      }
    },
    {
      path: '/user/permisos',
      name: 'Permisos de Grupo (Old)',
      component: UserGroupPermissions,
      meta: {
        ifUserCan: {
          view: 'auth/permission'
        }
      },
      // ifCan: { View: 'Profile' } // (sic)
    },
    {
      path: '/user/profile',
      name: 'Perfil de usuario',
      component: UserProfile,
    },
    {
      path: '/user/profile/edit',
      name: 'Editar perfil',
      component: EditUserProfile,
      meta: {
        ifUserCan: {
          change: 'Users/jbuser'
        }
      },
    },
    {
      path: '/user/profile/change_password',
      name: 'Cambiar contraseña',
      component: ChangePassword,
      meta: {
        ifUserCan: {
          change: 'Users/jbuser'
        }
      },
    },
  ],
}
export default userPages



// WEBPACK FOOTER //
// ./src/router/userRoutes.js